
export const tournamentsData = [
  {
    id: 1,
    name: 'Новогодний Марафон',
    casino: 'Vavada Casino',
    prizePool: '5 000 000 ₽',
    startDate: '01.01.2026',
    endDate: '31.01.2026',
    participants: 12500,
    status: 'active',
    image: 'https://public.readdy.ai/ai/img_res/db0b581bb38c6f82c4fd05c1976e4e71.jpg',
    prizes: ['1 место: 500 000 ₽', '2 место: 250 000 ₽', '3 место: 100 000 ₽'],
    rules: 'Играйте в слоты Pragmatic Play и набирайте очки'
  },
  {
    id: 2,
    name: 'Битва Слотов',
    casino: 'Pin-Up Casino',
    prizePool: '3 000 000 ₽',
    startDate: '15.01.2026',
    endDate: '15.02.2026',
    participants: 8700,
    status: 'active',
    image: 'https://readdy.ai/api/search-image?query=epic%20slot%20machine%20battle%20tournament%20banner%20with%20lightning%20effects%20on%20purple%20background%2C%20competitive%20gaming%20event%20design%2C%20dynamic%20action%20style%2C%20high%20quality%20digital%20art&width=400&height=250&seq=41&orientation=landscape',
    prizes: ['1 место: 300 000 ₽', '2 место: 150 000 ₽', '3 место: 75 000 ₽'],
    rules: 'Соревнуйтесь за максимальный множитель выигрыша'
  },
  {
    id: 3,
    name: 'Королевский Турнир',
    casino: '1xSlots',
    prizePool: '10 000 000 ₽',
    startDate: '01.02.2026',
    endDate: '28.02.2026',
    participants: 0,
    status: 'upcoming',
    image: 'https://readdy.ai/api/search-image?query=royal%20casino%20tournament%20banner%20with%20crown%20and%20golden%20elements%20on%20deep%20blue%20background%2C%20prestigious%20gambling%20event%20design%2C%20elegant%20luxury%20style%2C%20premium%20digital%20illustration&width=400&height=250&seq=42&orientation=landscape',
    prizes: ['1 место: 1 000 000 ₽', '2 место: 500 000 ₽', '3 место: 250 000 ₽'],
    rules: 'Еженедельные этапы с накоплением очков'
  },
  {
    id: 4,
    name: 'Мобильный Чемпионат',
    casino: 'Starda Casino',
    prizePool: '2 000 000 ₽',
    startDate: '10.01.2026',
    endDate: '10.02.2026',
    participants: 5400,
    status: 'active',
    image: 'https://readdy.ai/api/search-image?query=mobile%20gaming%20championship%20banner%20with%20smartphone%20and%20casino%20elements%20on%20teal%20gradient%20background%2C%20modern%20tech%20gambling%20event%20design%2C%20sleek%20professional%20style%2C%20high%20quality%20digital%20art&width=400&height=250&seq=43&orientation=landscape',
    prizes: ['1 место: 200 000 ₽', '2 место: 100 000 ₽', '3 место: 50 000 ₽'],
    rules: 'Играйте только с мобильного устройства'
  },
  {
    id: 5,
    name: 'Live Казино Баттл',
    casino: 'Riobet',
    prizePool: '4 000 000 ₽',
    startDate: '20.01.2026',
    endDate: '20.02.2026',
    participants: 3200,
    status: 'active',
    image: 'https://readdy.ai/api/search-image?query=live%20casino%20tournament%20banner%20with%20roulette%20wheel%20and%20cards%20on%20elegant%20black%20and%20gold%20background%2C%20premium%20live%20dealer%20event%20design%2C%20sophisticated%20luxury%20style%2C%20professional%20digital%20illustration&width=400&height=250&seq=44&orientation=landscape',
    prizes: ['1 место: 400 000 ₽', '2 место: 200 000 ₽', '3 место: 100 000 ₽'],
    rules: 'Соревнуйтесь в играх с живыми дилерами'
  }
];

export const promotionsData = [
  {
    id: 1,
    title: 'Кэшбэк 15% каждую неделю',
    casino: 'Vavada Casino',
    type: 'cashback',
    value: '15%',
    validUntil: '31.12.2026',
    description: 'Получайте возврат 15% от проигрыша каждый понедельник'
  },
  {
    id: 2,
    title: '100 фриспинов за депозит',
    casino: 'Pin-Up Casino',
    type: 'freespins',
    value: '100 FS',
    validUntil: '28.02.2026',
    description: 'Пополните счет от 2000₽ и получите 100 бесплатных вращений'
  },
  {
    id: 3,
    title: 'Бонус на день рождения',
    casino: '1xSlots',
    type: 'birthday',
    value: '50% + 50 FS',
    validUntil: 'Постоянно',
    description: 'Специальный бонус в честь вашего дня рождения'
  },
  {
    id: 4,
    title: 'Удвоение депозита по пятницам',
    casino: 'Joycasino',
    type: 'reload',
    value: '100%',
    validUntil: '31.03.2026',
    description: 'Каждую пятницу получайте 100% бонус на депозит'
  }
];
